import { useContext, useEffect } from "react";

import { css } from "@compiled/react";
import { UniformSlot } from "@uniformdev/canvas-react";
import {
    FilterableItemIndexContext,
    useFilterableItemRegistry
} from "src/uniform/contexts/filterable-item-registry-context";

export interface FilterableItemProps {
    /**
     * The raw data object for this item, bound to the current Loop iteration
     * via a Uniform data resource. Used by FilterableGallery to drive
     * filtering, search, and sort — not used for rendering.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data?: any;
    /** Makes the wrapper and its direct rendered child stretch to the gallery row height. */
    fullHeight?: boolean | { value?: boolean };
}

const FilterableItem = ({ data, fullHeight = false }: FilterableItemProps) => {
    const registry = useFilterableItemRegistry();
    const index = useContext(FilterableItemIndexContext);
    const isFullHeight = resolveBooleanParameter(fullHeight, false);

    useEffect(() => {
        if (!registry) return;
        registry.registerItem(index, data);
        return () => registry.unregisterItem(index);
    }, [registry, index, data]);

    return (
        <div css={isFullHeight && fullHeightStyle}>
            <div css={isFullHeight && fullHeightStyle}>
                <UniformSlot name="content" />
            </div>
        </div>
    );
};

const resolveBooleanParameter = (
    parameter: boolean | { value?: boolean } | undefined,
    defaultValue: boolean
) => {
    if (typeof parameter === "boolean") return parameter;
    if (typeof parameter?.value === "boolean") return parameter.value;
    return defaultValue;
};

const fullHeightStyle = css({
    height: "100%",
    display: "grid"
});

export default FilterableItem;
